<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body">
                   <p class="rcclConfirm-title">注册信息分享授权</p>
                   <div class="rcclConfirm-content">请您授权同意将注册信息（即邮箱及手机号）分享给皇家加勒比游轮海外航线销售合作伙伴（即中旅途易旅游有限公司北京绿洲旅游分公司），以自动登录至其网站搜索和获取海外航线的优先合作伙伴折扣信息。</div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" style="display: block; margin: auto;" @click="allowTuiClick(false)">不同意，继续预订（不享受优先合作伙伴折扣）</button>
                    <button type="button" class="btn btn-primary" style="display: block; margin: 15px auto auto; width: 320px;" @click="allowTuiClick(true)">同意授权，获取优先合作伙伴折扣</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AllowTuiPopup",
    props: {
        isShow: {
            type: Boolean
        },
        onAllowTuiClick: {
            type: Function
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        },
        allowTuiClick (isAllow) {
            this.onAllowTuiClick(isAllow)
            this.onModalClose()
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal-body {
    padding: 20px;
}
.modal-dialog {
    top: 15%;
    
}

.modal {
    .common-modal-close {
        position: absolute;
        width: 28px;
        top: 3px;
        right: 5px;
        z-index: 2;
        cursor: pointer;
    }

    .rcclConfirm-title {
        margin-top: 23px;
        text-align: center;
        font-size: 20px;
        color: #006ab9;
        font-weight: bold;
        margin-bottom: 30px;
    }

    .rcclConfirm-content {
        font-size: 14px;
        color: #747d80;
        padding: 0 35px;
        text-align: left;
        line-height: 20px;
    }

    .modal-footer {
        padding: 25px 15px 50px 15px;
        text-align: center;
        border-top: none;
        .btn, .btn:hover, .btn:focus {
            color: #282b2c;
            background-color: white;
            border: solid 1px #D3DADD;
        }
        .btn-primary, .btn-primary:hover, .btn-primary:focus {
            background-color: #fcc301;
            border-color: #fcc301;
            color: #282b2c;
        }
        
    }

}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>